/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AffectedPathLinkStructure } from './AffectedPathLinkStructure';
import type { ConnectionLinkRefStructure } from './ConnectionLinkRefStructure';
import type { ExtensionsStructure } from './ExtensionsStructure';
import type { LineRefStructure } from './LineRefStructure';
import type { NaturalLanguageStringStructure } from './NaturalLanguageStringStructure';
import type { StopPointRefStructure } from './StopPointRefStructure';
import type { ZoneRefStructure } from './ZoneRefStructure';

export type AffectedConnectionLinkStructure = {
  connectionLinkRef?: Array<ConnectionLinkRefStructure>;
  connectionName?: NaturalLanguageStringStructure;
  allLines?: any;
  lineRef?: Array<LineRefStructure>;
  connectingStopPointRef?: StopPointRefStructure;
  connectingStopPointName?: NaturalLanguageStringStructure;
  connectingZoneRef?: ZoneRefStructure;
  connectionDirection?: AffectedConnectionLinkStructure.connectionDirection;
  affectedPathLink?: Array<AffectedPathLinkStructure>;
  extensions?: ExtensionsStructure;
};

export namespace AffectedConnectionLinkStructure {
  export enum connectionDirection {
    TO = 'TO',
    FROM = 'FROM',
    BOTH = 'BOTH',
  }
}
